export class User {
  constructor(
      public createdDate: string = "1900-01-01",
      public createdBy: string = "",
      public id: string = "",
      public externalId: string = "",
      public firstname: string = "",
      public lastname: string = "",
      public email: string = "",
      public type: string = "",
      public username: string = "",
      public phoneNumber: string = "",
      public hashCode: string = "",
      public whatsappNotifiable: boolean = false,
      public emailNotifiable: boolean = false,
      public fullname: string = "",
      public active: boolean = true,
      public admin: boolean = true,
      public companyId: string = "",
      public companyName: string = "",
      public companySet: boolean = false,
      public profileSet: boolean = false,
      public userFile?: File
  ) {}
}


export class File {
  constructor(
    public createdDate: string = "",
    public createdBy: string,
    public id: string,
    public userId: string,
    public file: {
      createdDate: string;
      createdBy: string;
      id: string;
      name: string;
      contentType: string;
      fileType: string;
    }
  ) {}
}